import { ActionTree } from 'vuex';
import { EmpathizeState } from '../../models';
import { RootStoreState } from '../store.interfaces';
import { GetIdentifierSuggestionsAction } from './actions/get-identifier-suggestions.action';
import { GetPopularSearchesAction } from './actions/get-popular-searches.action';
import { GetResultsSuggestionsAction } from './actions/get-results-suggestions.action';
import { GetTermSuggestionsAction } from './actions/get-term-suggestions.action';
import { MoveSelectedAction } from './actions/move-selected.action';

export const EMPATHIZE_ACTIONS: ActionTree<EmpathizeState, RootStoreState> = {
  ...new GetPopularSearchesAction().actions,
  ...new GetTermSuggestionsAction().actions,
  ...new MoveSelectedAction().actions,
  ...new GetResultsSuggestionsAction().actions,
  ...new GetIdentifierSuggestionsAction().actions
};
